export default __webpack_public_path__ + "static/media/P_Palhaco.626c2584.svg";